import { LoginCallback } from '@okta/okta-react';
import { lazy, Suspense } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Layout } from '@/Layout';
import { SecureRoute } from '@/router/SecureRouter';

const Login = lazy(() => import('@/components/Login'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const Extractors = lazy(() => import('@/pages/Extractors'));
const PayslipExtractor = lazy(() => import('@/pages/PayslipExtractor'));
const Staff = lazy(() => import('@/pages/Staff'));

export const AppRouter = () => {
  return (
    <Router>
      <Suspense
        fallback={
          <div className="flex min-h-screen items-center justify-center">
            <div className="h-8 w-8 animate-spin rounded-full border-gray-900 border-b-2" />
          </div>
        }
      >
        <Routes>
          <Route element={<Login />} path="/login" />
          <Route element={<LoginCallback />} path="/login/callback" />
          <Route
            element={
              <SecureRoute>
                <Layout />
              </SecureRoute>
            }
            path="/"
          >
            <Route element={<Navigate replace to="/dashboard" />} index />
            <Route element={<Dashboard />} path="dashboard" />
            <Route path="extractors">
              <Route element={<Extractors />} index />
              <Route element={<PayslipExtractor />} path="payslip" />
            </Route>
            <Route element={<Staff />} path="staff" />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};
